import React from "react";
import { cn } from "../../lib/cn";

const SP = { sm: "h-4 w-4", md: "h-6 w-6", lg: "h-9 w-9" };

/** Inline loading spinner (inherits currentColor). */
export function Spinner({ size = "md", className }) {
  return (
    <svg className={cn("animate-spin text-primary", SP[size], className)} viewBox="0 0 24 24" fill="none" role="status" aria-label="Loading">
      <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
      <path className="opacity-90" d="M22 12a10 10 0 0 1-10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

/** Full-area centered loader. */
export function Loader({ label = "Loading…", className }) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-3 py-16 text-muted", className)}>
      <Spinner size="lg" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

/** Empty / zero-state. */
export function EmptyState({ icon, title, description, action, className }) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-line/20 bg-surface/50 px-6 py-16 text-center", className)}>
      {icon && <div className="flex h-10 w-10 items-center justify-center rounded-md bg-primary/10 text-primary">{icon}</div>}
      {title && <h3 className="font-display text-lg font-semibold text-ink">{title}</h3>}
      {description && <p className="max-w-sm text-sm text-muted">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}

export function Divider({ className, ...props }) {
  return <hr className={cn("border-0 border-t border-line/12", className)} {...props} />;
}

export default Spinner;
